/**
 * Lightweight Business Hub shell skeleton for route-level Suspense.
 * Skeleton-only — no hub modules, no data hooks.
 */
import { Skeleton } from '../../components/ui/Skeleton';

/** Hub header + tab strip + body placeholder while BusinessHub chunk loads. */
export function BusinessHubSkeleton(): JSX.Element {
  return (
    <div className="flex h-full min-h-[50vh] flex-col bg-gray-50" role="status" aria-busy="true">
      <div className="flex-shrink-0 border-b border-gray-200 bg-white px-4 py-4 sm:px-6">
        <Skeleton className="h-7 w-40" />
        <Skeleton className="mt-2 h-3 w-64 max-w-full" />
        <div className="mt-4 flex gap-2 overflow-hidden">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-8 w-20 shrink-0 rounded-full" />
          ))}
        </div>
      </div>
      <div className="flex-1 space-y-4 p-4 sm:p-6">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="rounded-xl border border-gray-200 bg-white p-4 space-y-2">
              <Skeleton className="h-3 w-16" />
              <Skeleton className="h-7 w-20" />
              <Skeleton className="h-3 w-24" />
            </div>
          ))}
        </div>
        <div className="rounded-xl border border-gray-200 bg-white p-4 space-y-3">
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-48 w-full rounded-lg" />
        </div>
      </div>
    </div>
  );
}
